import { useCallback, useState, useRef } from 'react';
import { changeURL } from '@/utils';

export default () => {
  const [inDetail, setInDetail] = useState(false);
  const [inMinDetail, setInMinDetail] = useState(false);
  const [detailId, toggleSetDetailId] = useState('');
  const [detailItem, setDetailItem] = useState<any>(null);
  const [recommendActive, setRecommendActive] = useState("like")
  const [recommendCategoryId, setRecommendCategoryId] = useState([])
  const [isDetailSmall, setDetailIsSmall] = useState(document.body.clientWidth <= 1100)
  const openDetailTimer = useRef<any>(null)
  const closeDetailTimer = useRef<any>(null)
  const closeExpandWidthTimer = useRef<any>(null)
  const openIframeWidthTimer = useRef<any>(null)
  // setDetailItem 的 timer
  const setDetailItemTimer = useRef<any>(null)
  // setDetailItem 的 timer
  const [isHoverExpand, toggleIsHoverExpand] = useState(false)
  // ref
  const isHoverExpandRef = useRef(false)
  // 滚动状态标记，用于阻止滚动时触发 Popover
  const isScrollingRef = useRef(false)
  // 包装一下setIsHoverExpand
  const setIsHoverExpand = useCallback((val: boolean) => {
    isHoverExpandRef.current = val
    toggleIsHoverExpand(val)
  }, [])
  const setDetailId = useCallback((val: any, append: boolean = true) => {
    if (append) {
      changeURL('detailId', val)
    }
    toggleSetDetailId(val) 
  }, [])
  const [offsetTop, setOffsetTop] = useState<number>(0);
  // 卡片详情的信息
  const [cardDetailInfo, setCardDetailInfo] = useState<any>(null)

  return {
    inDetail,
    setInDetail,
    detailId,
    setDetailId,
    detailItem,
    setDetailItem,
    recommendActive,
    setRecommendActive,
    recommendCategoryId,
    setRecommendCategoryId,
    isDetailSmall,
    setDetailIsSmall,
    openDetailTimer,
    closeDetailTimer,
    isHoverExpand,
    setIsHoverExpand,
    inMinDetail,
    setInMinDetail,
    isHoverExpandRef,
    openIframeWidthTimer,
    closeExpandWidthTimer,
    setDetailItemTimer,
    offsetTop,
    setOffsetTop,
    cardDetailInfo,
    setCardDetailInfo,
    isScrollingRef
  }
}
